import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.967 5.593 9.561 5h4.748l.593.593v2.374h2.967v1.187h-.64l-.747 8.952-.591.544H7.978l-.592-.544-.745-8.952H6V7.967h2.967V5.593Zm4.748.594v1.78h-3.56v-1.78h3.56ZM7.832 9.154h8.205l-.692 8.309H8.524l-.692-8.309Zm1.313 1.187.31 5.935h.892l-.31-5.935h-.892Zm2.345 5.935h.89v-5.935h-.89v5.935Zm2.032 0h.892l.31-5.935h-.89l-.312 5.935Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }